import * as yup from 'yup';

import { FINANCE_NUMBER_PATTERN } from '@/constants/patterns';

import { TranslatorFunction } from '@/types/i18n';

const MAX_TYPE_LENGTH = 30;
const MAX_VALUE_DIGITS = 12;

export function getLiabilitiesValidationSchema(t: TranslatorFunction) {
  return yup.object().shape({
    hasLiability: yup.boolean().required().nullable(),
    liabilities: yup.array().when('hasLiability', {
      is: true,
      then: schema =>
        schema
          .of(
            yup.object().shape({
              liabilityType: yup
                .string()
                .required(
                  t(
                    'moreInfo.form.yourFinances.liabilities.liabilityTypeRequired',
                  ),
                )
                .max(
                  MAX_TYPE_LENGTH,
                  t(
                    'moreInfo.form.yourFinances.liabilities.liabilityTypeMaxLength',
                  ),
                ),
              amount: yup
                .string()
                .required(
                  t('moreInfo.form.yourFinances.liabilities.valueRequired'),
                )
                .matches(
                  FINANCE_NUMBER_PATTERN,
                  t('moreInfo.form.yourFinances.liabilities.valuePattern'),
                )
                .max(
                  MAX_VALUE_DIGITS,
                  t('moreInfo.form.yourFinances.liabilities.valueMaxLength'),
                ),
            }),
          )
          .required(),
      otherwise: schema => schema.optional(),
    }),
  });
}
